const STORAGE_KEY = 'kiku:last-dept-slug';

export function useLastDepartment(): [string | null, (slug: string) => void] {
  const lastDeptSlug = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;

  function setLastDepartment(slug: string): void {
    localStorage.setItem(STORAGE_KEY, slug);
  }

  return [lastDeptSlug, setLastDepartment];
}
